import { handleActions, createActions } from 'redux-actions'
import { goBack } from 'connected-react-router'
import { takeLatest } from 'redux-saga/effects'
import { select, put } from 'redux-saga/effects'

export const {
  navbar: { configure, changeTitle, clickBack, setComputedHeight, reset },
} = createActions({
  NAVBAR: {
    CLICK_BACK: null,
    CONFIGURE: null,
    CHANGE_TITLE: null,
    SET_COMPUTED_HEIGHT: null,
    RESET: null,
  },
}) as any

function* watchClickBack() {
  yield takeLatest(clickBack, function* () {
    const onClickBack = yield select((state: Store.IState) => state.navbar.onClickBack)
    if (typeof onClickBack === 'function') onClickBack()
    else yield put(goBack())
  })
}

export const watchNavbarSagas = [watchClickBack]

const defaultState = {
  title: '',
  onClickBack: null,
  navbar: {
    isCustomerNavbar: false,
    isTransparent: false,
    isShowArrow: false,
  },
  computedHeight: 0,
  rightItemConfig: [],
}

export default handleActions<Navbar.IState, any>(
  {
    [configure]: (
      state,
      {
        payload: {
          title,
          onClickBack,
          rightItemConfig,
          navbar: { isCustomerNavbar = false, isTransparent = false, isShowArrow = false } = {},
        },
      }
    ) => {
      return {
        ...state,
        title,
        onClickBack,
        rightItemConfig,
        navbar: { ...state.navbar, isCustomerNavbar, isTransparent, isShowArrow },
      }
    },
    [changeTitle]: (state, { payload: { title } }) => {
      return { ...state, title }
    },
    [setComputedHeight]: (state, { payload: height }) => {
      return { ...state, computedHeight: height }
    },
    [reset]: (state, { payload: height }) => {
      return { ...defaultState }
    },
  },
  defaultState
)
